module.exports = __webpack_public_path__ + "img/2x.a5673db.jpg";